import { TableHeadersType } from "../../tableHeadersType";

export const STOCK_LIMIT_REPORT_TABLE_HEADERS:TableHeadersType[]=[
    {
        label:"SKU Number",
        value:"sku_number",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Stock name",
        value:"stock_item_name",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Stock Group name",
        value:"stock_group_name",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Stock unit name",
        value:"stock_unit_name",
        checked:true,
        defaultChecked:true
    },
   
    {
        label:"Current quantity",
        value:"closing_qty",
        checked:true,
        defaultChecked:true
    },
   
    {
        label:"Minimum Quantity",
        value:"min_quantity",
        checked:true,
        defaultChecked:true
    },
    {
        label:"maximum Quantity",
        value:"max_quantity",
        checked:true,
        defaultChecked:true
    },
   
]

export const STOCK_LIMIT_REPORT_WITH_GRAPH_TABLE_HEADERS:TableHeadersType[]=[
    {
        label:"SKU Number",
        value:"sku_number",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Stock name",
        value:"stock_item_name",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Stock Group name",
        value:"stock_group_name",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Stock unit name",
        value:"stock_unit_name",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Visual",
        value:"graph",
        checked:true,
        defaultChecked:true
    }
   
]

export const STOCK_LIMIT_REPORT_QUANTITY_OPTIONS:TableHeadersType[]=[
    {
        label:"All",
        value:"0",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Max",
        value:"1",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Min",
        value:"2",
        checked:true,
        defaultChecked:true
    },
  

   
]